// removed by extract-text-webpack-plugin
module.exports = {"contactsPlaceholder":"_3KTq2SicxyVU8VprICgY_j","placeholderTitle":"q9TLHb8ltubfUT1tSSyNJ","placeholderRow":"_6WsnWgeZnmDKGAJo5uruG","mobile":"_168JlKfPJVpkhvdXC0wDxX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/ContactsPlaceholder/ContactsPlaceholder.scss
// module id = 1722
// module chunks = 0